





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { LegendMap, TypeVehicleState } from '../utils';
import { contact, moderating, off, on_driving_working, outdated } from '../models';
import { map, startWith } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component<Legend>({
    subscriptions() {
        return {
            mouseenter$: this.mouseEvent$.pipe(
                startWith(false),
                map<boolean, boolean>(enter => !enter)
            )
        };
    }
})
export default class Legend extends Vue {
    @Prop() legendMap: LegendMap | null;
    mouseEvent$: Subject<boolean> = new Subject();
    mouseenter$: boolean;

    handleMouseEvent(enter: boolean): void {
        this.mouseEvent$.next(enter);
    }
}
